import { Avatar } from '@repletoryreach/sdk-ui';

/**
 * A person's initials in a tinted tile.
 *
 * Two letters for a person and one for an organisation is the split the design
 * uses, and it keeps a user row distinguishable from a tenant row at a glance.
 */
export function PersonAvatar({ name, size = 'sm' }: { name: string; size?: 'xs' | 'sm' | 'md' | 'lg' }) {
  const parts = name.trim().split(/[\s@._-]+/).filter(Boolean);
  const initials = parts.length > 1
    ? `${parts[0][0]}${parts[1][0]}`
    : name.slice(0, 2);

  return (
    <Avatar
      size={size}
      // Avatar is a circle by default; passing a radius token would square it
      // off, and the design keeps people round and organisations squared.
      shape="circle"
      aria-hidden
      style={{
        background: 'color-mix(in srgb, var(--rr-color-primary) 14%, transparent)',
        color: 'var(--rr-color-primary)',
        fontWeight: 700
      }}
    >
      {initials.toUpperCase()}
    </Avatar>
  );
}
